import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

const getUsuarioContexto = () => {
    const { user } = getAuthContext();
    return {
        idEmpresa: user?.idEmpresa || 1,
        idSucursal: user?.idSucursal || null,
        idUsuario: user?.id || null
    };
};

export const KardexService = {
    getAll: async (filterSucursalId = null) => {
        const { idEmpresa, idSucursal } = getUsuarioContexto();
        const params = { idEmpresa };
        
        const finalSucursal = filterSucursalId || idSucursal;
        if (finalSucursal) {
            params.idSucursal = finalSucursal;
        }
        const response = await getAxios().get('/api/kardex', { params });
        return response.data;
    },

    getByVariante: async (idVariante, filterSucursalId = null) => {
        const { idSucursal } = getUsuarioContexto();
        const params = {};

        const finalSucursal = filterSucursalId || idSucursal;
        if (finalSucursal) {
            params.idSucursal = finalSucursal;
        }
        const response = await getAxios().get(`/api/kardex/variante/${idVariante}`, { params });
        return response.data;
    },

    getByAlmacen: async (idAlmacen) => {
        const response = await getAxios().get(`/api/kardex/almacen/${idAlmacen}`);
        return response.data;
    },
    
    getByVarianteAndAlmacen: async (idVariante, idAlmacen) => {
        const response = await getAxios().get(`/api/kardex/variante/${idVariante}/almacen/${idAlmacen}`);
        return response.data;
    },

    create: async (kardex) => {
        const { idEmpresa, idSucursal, idUsuario } = getUsuarioContexto();
        const payload = {
            ...kardex,
            idEmpresa: kardex.idEmpresa || idEmpresa,
            idUsuario: kardex.idUsuario || idUsuario,
            idSucursal: kardex.idSucursal || idSucursal
        };
        const response = await getAxios().post('/api/kardex', payload);
        return response.data;
    }
};
